import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from 'redux';
import MenuHorizontal from "../../layouts/MenuHorizontal";
import MenuVertical from '../../layouts/MenuVertical';
import { Icon, Button, Form } from "semantic-ui-react";
import CamposCondominio from "./CamposCondominio";
import { CabecalhoForm, RodapeForm } from "../../layouts/FormUI";
import { create, findEnderecoByCep } from "../../../actions/condominio";
import * as FormValidator from "../../../utils/formValidator";
import Erro from '../../layouts/mensagens/Erro';

class CadastrarCondominio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      condominio: {
        nome: "",
        documento: "",
        usarFracaoIdeal: false,
        exibirDocsLinksVotacao: true,
        endereco: {
          cep: "",
          logradouro: "",
          bairro: "",
          cidade: "",
          numero: "",
          uf: "",
          complemento: ""
        }
      },
      errors: {},
      sucesso: false,
      loading: false,
      loadingCep: false,
      ruaBairroManual: false,
      enderecoManual: false,
    };
  }

  onChangeDocumento = e => {
    this.setState({
      condominio: { ...this.state.condominio, [e.target.name]: e.target.value.replace(/\D/g, '') },
      errors: {}
    });
  }

  onChange = e => {
    this.setState({
      condominio: { ...this.state.condominio, [e.target.name]: e.target.value },
      errors: {}
    });
  };

  onChangeEndereco = async e => {
    const ufSizeValid = e.target.name !== 'uf' || (e.target.name === 'uf' && e.target.value.length <= 2);
    const cepSizeValid = e.target.name !== 'cep' || (e.target.name === 'cep' && e.target.value.length <= 8);

    if (ufSizeValid && cepSizeValid) {
      this.setState({
        condominio: {
          ...this.state.condominio,
          endereco: {
            ...this.state.condominio.endereco,
            [e.target.name]: e.target.value
          }
        },
        errors: {}, sucesso: false
      });

      if (e.target.name === "cep" && e.target.value && !isNaN(e.target.value) && e.target.value.length === 8) {
        this.setState({ loadingCep: true });

        const endereco = await this.props.findEnderecoByCep(e.target.value);
        if (endereco) {
          this.setState({
            condominio: {
              ...this.state.condominio,
              endereco: {
                ...this.state.condominio.endereco,
                logradouro: endereco.logradouro,
                bairro: endereco.bairro,
                cidade: endereco.localidade,
                uf: endereco.uf,
              }
            },
            ruaBairroManual: !endereco.logradouro || !endereco.bairro,
            loadingCep: false,
          });
        } else {
          this.setState({
            condominio: {
              ...this.state.condominio,
              endereco: {
                ...this.state.condominio.endereco,
                logradouro: '',
                bairro: '',
                cidade: '',
                numero: '',
                uf: '',
                complemento: '',
              }
            },
            ruaBairroManual: false,
            enderecoManual: true,
            loadingCep: false,
          });
        }
      }
    }
  };

  onChangeUsarFracaoIdeal = (e, { name, checked }) => {
    this.setState({
      condominio: { ...this.state.condominio, [name]: checked },
      errors: {},
    });
  };

  onExibirDocsLinksVotacao = (e, { name, checked }) => {
    this.setState({
      condominio: { ...this.state.condominio, [name]: checked },
      errors: {},
    });
  };

  onVotoSecreto = (e, { name, checked }) => {
    this.setState({
      condominio: { ...this.state.condominio, [name]: checked },
      errors: {},
    });
  };

  validate = (condominio) => {
    const errors = {};

    if (FormValidator.isVazio(condominio.nome)) {
      errors.nome = "Nome é obrigatório";
    }

    if (FormValidator.isVazio(condominio.documento)) {
      errors.documento = "Documento é obrigatório";
    } else if (!FormValidator.isCpf(condominio.documento) && !FormValidator.isCnpj(condominio.documento)) {
      errors.documento = 'Documento inválido';
    }

    if (!FormValidator.isVazio(condominio.endereco.cep) && !FormValidator.isCep(condominio.endereco.cep)) {
      errors.cep = "CEP inválido";
    }

    return errors;
  };

  onSubmitCadastrar = async (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.condominio);
    this.setState({ errors });
    if (FormValidator.objIsEmpty(errors)) {
      this.setState({ loading: true });
      await this.props.create(this.state.condominio);
      this.setState({
        loading: false,
        sucesso: FormValidator.objIsEmpty(this.props.errors),
        errors: this.props.errors
      })
    }
  };

  onToggle = (name, checked) => {
    this.setState({ condominio: { ...this.state.condominio, [name]: checked }, errors: {} });
  };

  render() {
    const { condominio, errors, loading, loadingCep, sucesso, ruaBairroManual, enderecoManual } = this.state;
    return (
      <div>
        <MenuHorizontal />
        <div className="corpo-dashboard">
          <MenuVertical page="condominios" />
          <div className="va-imp-pagina">
            <CabecalhoForm
              voltar="/"
              voltarTexto="Condomínios / Sociedades / Associações"
              titulo="Cadastrar condomínio / sociedade / associação"
              descricao="Informe os dados básicos. Depois você cadastra as unidades votantes e contrata o plano."
            />
            {sucesso && (
              <div className="va-res-banner sucesso" role="status">
                <Icon name="check circle outline" size="big" />
                <div>
                  <b>Cadastro realizado com sucesso</b>
                  <p>Agora cadastre as unidades votantes e contrate o plano para realizar assembleias.</p>
                  <div className="va-res-acoes">
                    <Link to="/" className="ui button btn-ui-1 small"><Icon name="building" /> Ver meus cadastros</Link>
                  </div>
                </div>
              </div>
            )}
            {!errors.global && !sucesso && !!errors.error && <Erro text={errors.error} tipo="block" />}
            {!sucesso && (
              <Form onSubmit={this.onSubmitCadastrar} loading={loading} autoComplete="off" className="va-imp">
                <CamposCondominio
                  condominio={condominio}
                  errors={errors}
                  loadingCep={loadingCep}
                  ruaBairroManual={ruaBairroManual}
                  enderecoManual={enderecoManual}
                  onChange={this.onChange}
                  onChangeDocumento={this.onChangeDocumento}
                  onChangeEndereco={this.onChangeEndereco}
                  onToggle={this.onToggle}
                />
                <RodapeForm>
                  <Button type="submit" loading={loading} disabled={loading} className="btn-ui-1" size="large">
                    <Icon name="save" /> Cadastrar
                  </Button>
                  <Link to="/" className="ui basic large button">Cancelar</Link>
                </RodapeForm>
              </Form>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    condominio: state.condominio.condominio,
    condominios: state.condominio.condominios,
    usuario: state.user.user,
    errors: state.condominio.errors
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    create,
    findEnderecoByCep
  }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(CadastrarCondominio);
